<template>
  <div class="super-tree-item">
    <div class="header">
      <img
        class="toggle-btn"
        v-if="value.children && value.children.length > 0"
        @click="onExpandNode"
        :src="require('../icon/arrow.svg')"
        :class="{ 'is-expanded': loaclValue.expanded }"
      />
      <input
        v-if="loaclValue.editing"
        class="input"
        v-model="loaclValue.label"
        ref="nodeInput"
      />
      <div class="label" v-else>{{ loaclValue.label }}</div>
      <div class="actions">
        <template v-if="loaclValue.editing">
          <img
            class="btn"
            :src="require('../icon/check.svg')"
            alt="保存"
            @click="onConfirm"
          />
          <img
            class="btn"
            :src="require('../icon/cancel.svg')"
            alt="取消"
            @click="onCancel"
          />
        </template>
        <template v-else>
          <img
            v-if="depth < 5"
            class="btn"
            :src="require('../icon/create.svg')"
            alt="新建"
            @click="onAddNode"
          />
          <img
            class="btn"
            :src="require('../icon/edit.svg')"
            alt="编辑"
            @click="onEdit"
          />
          <img
            class="btn"
            :src="require('../icon/delete.svg')"
            alt="删除"
            v-if="!root"
            @click="onDelete"
          />
        </template>
      </div>
    </div>
    <div
      class="children"
      v-if="loaclValue.expanded && value.children && value.children.length > 0"
    >
      <TreeItem
        v-for="(item, index) in value.children"
        :key="item.value"
        :value="item"
        :index="index"
        :depth="depth + 1"
        @on-delete-child="onDeleteChild"
        @on-change="$emit('on-change')"
      ></TreeItem>
    </div>
  </div>
</template>
<script>
import { uuid } from "@qingjin/jsuper";
export default {
  name: "SuperTreeItem",
  props: {
    value: Object,
    index: Number,
    root: Boolean,
    depth: Number,
  },
  data() {
    return {
      loaclValue: {},
    };
  },
  computed: {
    isCreating() {
      return !this.value.value;
    },
  },
  watch: {
    value: {
      handler(newValue) {
        if (newValue) {
          this.setLocalValue();
        }
      },
      immediate: true,
    },
  },

  mounted() {
    if (this.loaclValue.editing) {
      this.$nextTick(() => {
        this.$refs.nodeInput.focus();
      });
    }
  },
  methods: {
    setLocalValue() {
      this.loaclValue = {
        value: this.value.value,
        label: this.value.label,
        expanded: this.value.expanded,
        editing: this.value.editing,
      };
    },
    onExpandNode() {
      this.value.expanded = this.loaclValue.expanded =
        !this.loaclValue.expanded;
    },
    onAddNode() {
      this.value.expanded = this.loaclValue.expanded = true;
      this.value.children.push({
        value: "",
        label: "",
        expanded: false,
        editing: true,
        children: [],
      });
      this.$forceUpdate();
    },
    onConfirm() {
      if (this.isCreating) {
        this.value.value = this.loaclValue.value = uuid();
      }
      this.value.label = this.loaclValue.label;
      this.value.editing = this.loaclValue.editing = false;
      this.$emit("on-change");
    },
    onCancel() {
      if (this.isCreating) {
        // 取消新建
        this.$emit("on-delete-child", this.index);
      } else {
        this.loaclValue.editing = false;
        this.loaclValue.label = this.value.label;
      }
    },
    onDeleteChild(childIndex) {
      this.value.children.splice(childIndex, 1);
      this.$forceUpdate();
    },
    onEdit() {
      this.loaclValue.editing = true;
      this.$nextTick(() => {
        this.$refs.nodeInput.focus();
      });
    },
    onDelete() {
      this.$emit("on-delete-child", this.index);
      this.$emit("on-change");
    },
  },
};
</script>
<style lang="stylus" scoped>
.super-tree-item
  cursor pointer

  .header
    position relative
    display flex
    align-items center
    height 25px

    .toggle-btn
      width 14px
      height 14px
      margin-right 6px
      transform rotateZ(90deg)
      transform-origin center

      &.is-expanded
        transform rotateZ(180deg)

    .label
      line-height 1

    .input
      border 1px solid #04CBD8
      outline none
      padding 0 5px
      font-size 14px
      height 22px

    .actions
      display none
      margin-left 5px
      position absolute
      right 0

      .btn
        height 12px
        margin 0 3px

    &:hover
      background #E8F7F8

      .actions
        display flex

  .children
    padding-left 20px
</style>
